<div class="modal inmodal fade in show">
    <div class="modal-dialog">
        <form #form="ngForm" (submit)="onSubmit(form)" submittable autocomplete="off">
            <div class="modal-content" [ngClass]="{'sk-loading': isShowPreloader}">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <div class="title-block">
                        <h4 class="modal-title">Move {{modalType}}</h4>
                    </div>
                </div>
                <div class="modal-body">
                    <ul class="path">
                        <li *ngFor="let item of currentPath; let index = index;">
                            <a (click)="navigateToDirectory(item, index)" title="{{ item.name }}">
                                {{ item.name }}
                            </a>
                        </li>
                    </ul>

                    <div class="folders-list-wrapper">
                        <ul class="folders-list" *ngIf="foldersList.length > 0">
                            <li *ngFor="let folder of foldersList" (click)="goToDirectory(folder)">
                                <span class="fa directory-icon fa-folder"></span>
                                {{folder.name}}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-outer-primary mtv-primary-color mtv-primary-border"
                            type="button"
                            *ngIf="currentPath.length > 1"
                            (click)="goToParentFolder()">
                        Go To Parent Folder
                    </button>
                    <button class="btn btn-primary submit-btn" type="submit" [disabled]="isPathNotEqualOriginal()">
                        Move File
                    </button>
                </div>
            </div>
        </form>

        <spinner [spinnerShow]="isShowPreloader"></spinner>
    </div>
    <div class="modal-backdrop fade in" (click)="!isShowPreloader && hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/move-modal/move-modal.component.html